import { render, staticRenderFns } from "./MMPI.vue?vue&type=template&id=55d5e6a6&scoped=true"
import script from "./MMPI.vue?vue&type=script&lang=js"
export * from "./MMPI.vue?vue&type=script&lang=js"
import style0 from "./MMPI.vue?vue&type=style&index=0&id=55d5e6a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d5e6a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
